import { gql } from '@apollo/client';

import { getClient } from 'lane-shared/apollo';
import { 
  GroupType, 
  DeleteProductCategoryRequest 
} from 'graphql-query-contracts';
import { convertToUUID } from 'uuid-encoding';

export async function deleteCategoryMutation(
  categoryId: string,
  channelId: string
) {
  const deleteCategoryMutationQuery = gql`
    mutation deleteProductCategory(
      $deleteProductCategoryRequest: DeleteProductCategoryRequest!
    ) {
      deleteProductCategory(
        deleteProductCategoryRequest: $deleteProductCategoryRequest
      )
    }
  `;

  const result = await getClient().mutate<
    { deleteProductCategory: void },
    { deleteProductCategoryRequest: DeleteProductCategoryRequest }
  >({
    mutation: deleteCategoryMutationQuery,
    variables: {
      deleteProductCategoryRequest: {
        productCategoryId: convertToUUID(categoryId),
        groupType: GroupType.GroupTypeActivateChannel,
        groupId: convertToUUID(channelId),
      },
    },
  });

  return result.data;
}
